import TableRenderer from './TableRenderer';
import TdRenderer from './TdRenderer';
import ThRenderer from './ThRenderer';
export { CellProperties, Coordinates, DisplayCell, HeuristicTablePluginConfig, HTMLTableProps, TableCell, TableFlexColumnContainer, TableFlexRowContainer, TableCellPropsFromParent, TableRoot } from './shared-types';
export { TableRenderer, ThRenderer, TdRenderer };
/**
 * Renderers to be merged in the `renderers` prop of `RenderHTML` component.
 *
 * @public
 */

const renderers = {
  table: TableRenderer,
  th: ThRenderer,
  td: TdRenderer
};
export { default as useHtmlTableProps } from './useHtmlTableProps';
export { default as useHtmlTableCellProps } from './useHtmlTableCellProps';
export { default as HTMLTable } from './HTMLTable';
export default renderers;
//# sourceMappingURL=index.js.map